"use strict";
// Copyright 2017-2018 Stratumn SAS. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var b64 = __importStar(require("base64-js"));
var errors = __importStar(require("./errors"));
var chainscript_pb_1 = require("./proto/chainscript_pb");
/**
 * Create an evidence from a protobuf object.
 * @param e protobuf evidence.
 */
function fromProto(e) {
    return new Evidence(e.version || "", e.backend || "", e.provider || "", e.proof || new Uint8Array(0));
}
exports.fromProto = fromProto;
/**
 * Deserialize an evidence.
 * @param evidenceBytes encoded bytes.
 * @returns the deserialized evidence.
 */
function deserialize(evidenceBytes) {
    var pbEvidence = chainscript_pb_1.stratumn.chainscript.Evidence.decode(evidenceBytes);
    return fromProto(pbEvidence);
}
exports.deserialize = deserialize;
/**
 * Convert a plain object to an evidence.
 * @param e plain object.
 */
function fromObject(e) {
    if (typeof e.proof === "string") {
        return new Evidence(e.version, e.backend, e.provider, b64.toByteArray(e.proof));
    }
    return new Evidence(e.version, e.backend, e.provider, e.proof);
}
exports.fromObject = fromObject;
/**
 * Evidences can be used to externally verify a link's existence at a given
 * moment in time.
 * An evidence can be a proof of inclusion in a public blockchain, a timestamp
 * signed by a trusted authority or anything that you trust to provide an
 * immutable ordering of your process' steps.
 */
var Evidence = /** @class */ (function () {
    function Evidence(version, backend, provider, proof) {
        this.version = version;
        this.backend = backend;
        this.provider = provider;
        this.proof = proof;
        this.validate();
    }
    /**
     * Validate that the evidence is well-formed.
     * The proof is opaque bytes so it isn't validated here.
     */
    Evidence.prototype.validate = function () {
        if (!this.version) {
            throw errors.ErrEvidenceVersionMissing;
        }
        if (!this.backend) {
            throw errors.ErrEvidenceBackendMissing;
        }
        if (!this.provider) {
            throw errors.ErrEvidenceProviderMissing;
        }
        if (!this.proof || this.proof.length === 0) {
            throw errors.ErrEvidenceProofMissing;
        }
    };
    /**
     * Serialize the evidence.
     * @returns evidence bytes.
     */
    Evidence.prototype.serialize = function () {
        var e = chainscript_pb_1.stratumn.chainscript.Evidence.fromObject(this);
        return chainscript_pb_1.stratumn.chainscript.Evidence.encode(e).finish();
    };
    /**
     * Convert to a plain object.
     * @argument conversionOpts specify how to convert certain types.
     * @returns a plain object.
     */
    Evidence.prototype.toObject = function (conversionOpts) {
        if (conversionOpts && conversionOpts.bytes === String) {
            return {
                backend: this.backend,
                proof: b64.fromByteArray(this.proof),
                provider: this.provider,
                version: this.version
            };
        }
        return {
            backend: this.backend,
            proof: this.proof,
            provider: this.provider,
            version: this.version
        };
    };
    return Evidence;
}());
exports.Evidence = Evidence;
//# sourceMappingURL=evidence.js.map